<template>
  <div id="base" class="bold">
    <app-header></app-header>
    <transition name="bounce">
      <router-view></router-view>
    </transition>
    <app-footer></app-footer>
  </div>
</template>
<script>
  import Header from './Header.vue'
  import Footer from './Footer.vue'

  export default {
    data () {
      return {}
    },
    components: {
      appHeader: Header,
      appFooter: Footer
    }
  }
</script>
<style lang="scss" scoped>

  @import "../style/common";

  #base {
    min-height: 100vh;
    width: 100%;
    background-color: $color_black;
    color: $color_white;
    overflow: hidden; //謎の右の隙間を消す
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .1s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// Base.vue?dfdb8364